import { useState } from 'react'
import { getSiblingPaths, getChildPaths, getAllPaths, getInitialExpandedPaths } from '../utils/leftNavHelper'

export const useLeftNavAccordion = (metadata, nodes = null) => {
    const [expandedPaths, setExpandedPaths] = useState(() => getInitialExpandedPaths(metadata))

    const toggleExpanded = (path, shouldExpand) => {
        setExpandedPaths((prev) => {
            const expandedPathsList = Object.keys(prev)
            const newExpandedPaths = new Set(expandedPathsList)

            if (shouldExpand) {
                // Get all possible paths for sibling detection
                const allPossiblePaths = nodes ? getAllPaths(nodes) : expandedPathsList
                const siblings = getSiblingPaths(path, allPossiblePaths)

                // Remove all sibling paths and their children
                siblings.forEach((sibling) => {
                    newExpandedPaths.delete(sibling)
                    const siblingChildren = getChildPaths(sibling, allPossiblePaths)
                    siblingChildren.forEach((child) => newExpandedPaths.delete(child))
                })

                // Add the path we want to expand
                newExpandedPaths.add(path)
            } else {
                // Remove this path and all its children
                newExpandedPaths.delete(path)
                const children = getChildPaths(path, expandedPathsList)
                children.forEach((child) => newExpandedPaths.delete(child))
            }

            // Convert Set back to object format
            const result = {}
            newExpandedPaths.forEach((path) => {
                result[path] = true
            })
            return result
        })
    }

    return {
        expandedPaths,
        toggleExpanded,
    }
}
